const VARIANTS = {
  default: { color: "text-zinc-950", dot: null },
  // Semáforo — colores que comunican estado
  activo: { color: "text-emerald-700", dot: "#047857" },       // tranquilidad / sano
  por_vencer: { color: "text-amber-600", dot: "#d97706" },     // precaución / urgencia media
  vencido: { color: "text-red-700", dot: "#b91c1c" },          // alarma
  accent: { color: "text-emerald-700", dot: null },
  muted: { color: "text-zinc-400", dot: null },
};

export default function KPI({ label, value, suffix = "", variant = "default", size = "md", testid, accent = false }) {
  const sizeCls =
    size === "xl"
      ? "text-[clamp(4rem,10vw,9rem)]"
      : size === "lg"
      ? "text-[clamp(3rem,7vw,6rem)]"
      : "text-[clamp(2.5rem,5vw,4.5rem)]";

  const resolvedVariant = accent && variant === "default" ? "accent" : variant;
  const cfg = VARIANTS[resolvedVariant] || VARIANTS.default;

  return (
    <div className="flex flex-col gap-2" data-testid={testid}>
      <div className="section-marker flex items-center gap-2">
        {cfg.dot && (
          <span
            className="inline-block w-2 h-2 rounded-full"
            style={{ background: cfg.dot }}
            aria-hidden
          ></span>
        )}
        <span>{label}</span>
      </div>
      <div className={`kpi-number ${sizeCls} ${cfg.color} transition-colors`}>
        {value}
        {suffix && <span className="text-zinc-400">{suffix}</span>}
      </div>
    </div>
  );
}
